import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LogoCompleta from "../../../assets/logonotify1.png";
import LogoIcone from "../../../assets/notifyicone.png";
import './Adicionarauto.css';


const HEADER_HEIGHT = 56;

const Adicionarauto = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [nome, setNome] = useState('');
  const [autos, setAutos] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Se veio nome da automação via navegação, adiciona automaticamente (uma vez)
  useEffect(() => {
    const nova = location?.state?.novaAutomacao || location?.state?.novaAutomacaoName;
    if (nova) {
      setAutos(prev => {
        // se veio objeto completo
        if (typeof nova === 'object') {
          if (prev.some(a => a.id === nova.id)) return prev;
          return [{
            id: nova.id ?? Date.now(),
            nome: nova.nome ?? '',
            ativo: nova.ativo ?? true,
            sentCount: nova.sentCount ?? 0,
            failures: nova.failures ?? 0,
            mensagens: nova.mensagens ?? [],
            contas: nova.contas ?? [],
            grupos: nova.grupos ?? [],
            acao: nova.acao ?? null,
            gatilho: nova.gatilho ?? null,
          }, ...prev];
        }
        // se veio apenas nome
        const nomeRecebido = String(nova || '').trim();
        if (nomeRecebido && !prev.some(a => a.nome === nomeRecebido)) {
          return [{ id: Date.now(), nome: nomeRecebido, ativo: true, sentCount: 0, failures: 0 }, ...prev];
        }
        return prev;
      });
      // limpa o state da rota para evitar re-adicionar se o usuário navegar para trás
      try { window.history.replaceState({ ...window.history.state, usr: { ...window.history.state?.usr } }, ''); } catch(e) {}
    }
  }, [location]);

  function cadastrar(e) {
    e.preventDefault();
    if (!nome.trim()) return;
    setAutos(prev => [{ id: Date.now(), nome, ativo: true }, ...prev]);
    setNome('');
  }

  function handleMenuToggle(id) {
    setOpenMenuId(prev => (prev === id ? null : id));
  }

  function handleEdit(id) {
    const atual = autos.find(a => a.id === id);
    if (!atual) return;
    // navegar para o fluxo de criação/edição com os dados atuais
    navigate('/Automacoeswp', { state: { editAutomacao: atual } });
    setOpenMenuId(null);
  }

  function handleDelete(id) {
    // abrir modal de confirmação
    setConfirmDeleteId(id);
    setOpenMenuId(null);
  }

  function confirmDelete() {
    if (confirmDeleteId == null) return;
    setAutos(prev => prev.filter(a => a.id !== confirmDeleteId));
    setConfirmDeleteId(null);
  }

  function cancelDelete() {
    setConfirmDeleteId(null);
  }

  useEffect(() => {
    const onDocClick = () => setOpenMenuId(null);
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <nav
        className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? ' menu-aberto' : ''}`}
        style={{
          width:
            window.innerWidth <= 768
              ? sidebarOpen
                ? "80vw"
                : 56
              : sidebarOpen
              ? 220
              : 70,
          maxWidth:
            window.innerWidth <= 768
              ? sidebarOpen
                ? 260
                : 56
              : sidebarOpen
              ? 220
              : 70,
          minWidth:
            window.innerWidth <= 768
              ? 56
              : sidebarOpen
              ? 220
              : 70,
          background: "#005c53",
          minHeight: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
          transition: "width 0.3s",
          alignItems: "center",
          boxShadow:
            window.innerWidth <= 768 && sidebarOpen
              ? "4px 0 16px rgba(0,0,0,0.18)"
              : "2px 0 8px rgba(0,0,0,0.10)",
          overflowX: "hidden",
          overflowY: "auto",
          scrollbarWidth: "thin",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: sidebarOpen ? "row" : "column",
            justifyContent: sidebarOpen ? "space-between" : "center",
            alignItems: "center",
            padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
            transition: "all 0.3s",
            gap: sidebarOpen ? 12 : 8,
          }}
        >
          {sidebarOpen ? (
            <a href="/app">
              <img src={LogoCompleta} alt="Logo Completa" style={{ height: 40, transition: "all 0.3s" }} />
            </a>
          ) : (
            <a href="/app">
              <img src={LogoIcone} alt="Logo Ícone" style={{ height: 32, width: 32, transition: "all 0.3s" }} />
            </a>
          )}
          <button
            onClick={() => setSidebarOpen((open) => !open)}
            className="btn btn-link text-white"
            style={{
              fontSize: 24,
              textDecoration: "none",
              boxShadow: "none",
              marginLeft: sidebarOpen ? 12 : 0,
              marginRight: 0,
              padding: 0,
              alignSelf: "center",
            }}
            title={sidebarOpen ? "Fechar menu" : "Abrir menu"}
          >
            <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </button>
        </div>
        <ul className="nav nav-pills flex-column mb-auto w-100"
          style={{
            alignItems: sidebarOpen ? "flex-start" : "center",
            gap: sidebarOpen ? 0 : -12,
            paddingBottom: 0,
          }}>
          <li className="nav-item w-100">
            <a
              href="/app"
              className="nav-link d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
                background: "#51a197",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: 8,
                transition: "background 0.3s",
              }}
            >
              <i className="bi bi-speedometer2" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12, color: "#fff" }}>Dashboard</span>}
            </a>
          </li>
          
          <li className="w-100">
            <a href="/Campanha" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-megaphone" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Campanha</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Adicoonarauto" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-robot" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Automações</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Contas" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-person-lines-fill" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Contas</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="/Operacoes" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-gear" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Operações</span>}
            </a>
          </li>

          <li className="w-100">
            <a
              href="/Blacklist"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-person-x" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Blacklist</span>}
            </a>
          </li>
          <li>
            
          </li>

          <li className="w-100">
            <a
              href="/Webhook"
              className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}
            >
              <i className="bi-link-45deg" style={{ fontSize: 22 }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Webhook</span>}
            </a>
          </li>
          <li>
            <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
          </li>



        <li><hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} /></li>
          <li className="w-100">
            <a href="#" className="nav-link text-white d-flex align-items-center"
              style={{
                justifyContent: sidebarOpen ? "flex-start" : "center",
                padding: sidebarOpen ? "8px 16px" : "8px 0",
                width: "100%",
              }}>
              <i className="bi bi-wifi" style={{ fontSize: 22, color: "#fff" }}></i>
              {sidebarOpen && <span style={{ marginLeft: 12 }}>Broadcasts</span>}
            </a>
          </li>
          <li><hr className="dropdown-divider" style={{ margin: "0.5rem 0" }} /></li>
          
        </ul>
      </nav>
      {/* Header fixo no topo, mas atrás do menu lateral */}
      <nav
        className="navbar navbar-expand-lg navbar-dark"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: HEADER_HEIGHT,
          background: "#005c53",
          zIndex: 1200,
          borderRadius: 0,
          marginLeft: 0,
        }}
      >
        <div style={{ marginLeft: sidebarOpen ? 220 : 70, transition: "margin-left 0.3s" }}>
          <span style={{ color: "#fff", fontWeight: "bold", fontSize: 20 }}>Automações</span>
        </div>
        <div className="ms-auto d-flex align-items-center pe-3">
          <div className="dropdown">
            <a
              href="#"
              className="nav-link d-flex align-items-center p-0"
              id="userDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ color: "#fff", cursor: "pointer" }}
            >
              <i
                className="bi bi-person-circle"
                style={{
                  fontSize: 28,
                }}
              ></i>
              <span
                className="d-none d-lg-inline ms-2"
                style={{
                  padding: "3px 5px",
                  borderRadius: 16,
                  transition: "background 0.2s",
                  display: "inline-block",
                }}
              >
                Nome do Usuário
              </span>
            </a>
            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
              <li>
                <a className="dropdown-item" href="/Editarperfil">Perfil</a>
              </li>
              
               <li>
                <a className="dropdown-item" href="#">Treinamentos</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Termos de uso</a>
              </li>

              <li>
                <a className="dropdown-item" href="#">Sair</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
      }}>
        {/* Conteúdo da página de automações */}
        <div className="container-fluid p-4" style={{ marginLeft: window.innerWidth <= 768 ? 56 : 0 }}>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 style={{ margin: 0 }}>Automações</h2>
            <button
              className="btn"
              style={{ background: "#51a197", color: "#fff", borderRadius: 8 }}
              onClick={() => navigate('/Automacoeswp')}
            >
              Adicionar
            </button>
          </div>

          <div className="mb-3">
            <input
              type="search"
              className="form-control"
              placeholder="Pesquisar..."
              aria-label="Pesquisar automações"
            />
          </div>

          <div className="adicionar-auto">
            <div className="boxes">
              {autos.map(a => (
                <div key={a.id} className="box">
                  <div className="box-header">
                    <div style={{display:'flex',alignItems:'center',gap:12}}>
                      <strong>{a.nome}</strong>
                    </div>

                    <div style={{display:'flex', alignItems:'center', gap:8}}>
                      <div className="box-meta" style={{display:'flex', alignItems:'center', gap:8}}>
                        <span className="sent-count" title="Vezes enviadas">
                          <i className="bi bi-send-fill" />
                          <span className="count-number">{a.sentCount ?? 0}</span>
                        </span>
                        <span className={`fail-info ${a.failures > 0 ? 'has-failures' : 'no-fail'}`} title={`Falhas: ${a.failures ?? 0}`}>
                          <i className="bi bi-exclamation-circle-fill" />
                          <span className="fail-count">{a.failures ?? 0}</span>
                        </span>
                        {a.ativo && <span className="pulse" title="Ativo" />}
                      </div>
                      <div style={{position:'relative'}}>
                        <button className="box-menu" title="Mais opções" onClick={(e) => { e.stopPropagation(); handleMenuToggle(a.id); }}>
                          <i className="bi bi-three-dots-vertical" />
                        </button>
                        {openMenuId === a.id && (
                          <div className="box-dropdown" onClick={(e) => e.stopPropagation()}>
                            <button className="dropdown-item" onClick={() => handleEdit(a.id)}>Editar</button>
                            <button className="dropdown-item" onClick={() => handleDelete(a.id)}>Excluir</button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {confirmDeleteId != null && (
        <div className="confirm-modal-overlay" onClick={cancelDelete}>
          <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
            <h3>Excluir automação</h3>
            <p>Tem certeza que deseja excluir esta automação? Esta ação não pode ser desfeita.</p>
            <div className="modal-actions">
              <button className="btn-cancel" onClick={cancelDelete}>Cancelar</button>
              <button className="btn-delete" onClick={confirmDelete}>Excluir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Adicionarauto;